import { InlineShareButtons } from "sharethis-reactjs"
import React from "react"
import PropTypes from "prop-types"

function SocialShareButtons(props) {
  const { title } = props
  const handleKeyDown = (e) =>{
    if (e.key=="Enter") {
      e.preventDefault();
      e.target.click();      
    }
  }
  return (
    <div
      onKeyDown={handleKeyDown}
      role="button"
      aria-label="Share Buttons"
    >
      <InlineShareButtons
        config={{
          alignment: "center", // alignment of buttons (left, center, right)
          color: "white", // set the color of buttons (social, white)
          enabled: true, // show/hide buttons (true, false)
          font_size: 20, // font size for the buttons
          language: "en", // which language to use (see LANGUAGES)
          networks: [
            // which networks to include (see SHARING NETWORKS)
            "facebook",
            "twitter",
            "linkedin",
            "print",
          ],
          padding: 15, // padding within buttons (INTEGER)
          radius: 40, // the corner radius on each button (INTEGER)
          size: 40, // the size of each button (INTEGER)

          // OPTIONAL PARAMETERS
          image:
            "https://images.ctfassets.net/zo243s55pyir/DMjqSCQfnUoWruF10FG23/31709d9aa466e035397f0207c3d40a3d/Mondelez_International_Snacking_Made_Right.png",
          description: "custom text", // (defaults to og:description or twitter:description)
          title:
            title && title.includes("- Breadcrumb Wrapper")
              ? title.split("-")[0]
              : title, // (defaults to og:title or twitter:title)
          message: "custom email text", // (only for email sharing)
          subject: "custom email subject", // (only for email sharing)
          // username: "custom twitter handle" // (only for twitter sharing)
        }}
      />
    </div>
  )
}

SocialShareButtons.propTypes = {
  title: PropTypes.string,
}

export default SocialShareButtons